import { mapGetters } from 'vuex'
import SiteSearchGroup from '@/components/search-group'
import { topic } from '@/api/topics'
import journal from '@/api/journal'

import CreateFile from './createFile.dialog.vue'
import help from '@/utils/help'
const columns = [
  {
    title: '',
    enTitle: 'Title',
    width: 300,
    dataIndex: 'titleText',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Journal',
    width: 200,
    dataIndex: 'journalList',
    slot: 'journalList'
  },
  {
    title: '',
    enTitle: 'Start Date',
    width: 120,
    dataIndex: 'startTime',
    slot: 'date',
    sort: true
  },
  {
    title: '',
    enTitle: 'Abstract Deadline',
    width: 120,
    dataIndex: 'abstractTime',
    slot: 'date',
    sort: true
  },
  {
    title: '',
    enTitle: 'Manuscript Deadline',
    width: 120,
    dataIndex: 'manuscriptTime',
    slot: 'date',
    sort: true
  },
  {
    title: '',
    enTitle: 'Submission Status',
    width: 100,
    dataIndex: 'released',
    slot: 'openStatus'
  },
  {
    title: '',
    enTitle: 'Status',
    width: 100,
    dataIndex: 'released',
    slot: 'status'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 230,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions'
  }
]
export default {
  components: {
    SiteSearchGroup,
    CreateFile
  },
  data() {
    return {
      columns,
      showAdv: false,
      journalList: [],
      dataSource: [],
      openSection: '',
      params: {
        released: '',
        volumeId: '',
        issueId: '',
        journalIdList: ''
      },
      startDate: [],
      endDate: [],
      pagination: {
        total: 0,
        size: 50,
        current: 1,
        sizeChange: true,
        onPageChange: this.getList,
        pageSizeOptions: [5, 10, 30, 50, 100], // 每页数量选项
        showQuickJumper: true
      },
      inputData: {},
      pdfType: 'Banner',
      isVisablePDF: false,
      loading: false,
      journalId: []
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      domain: 'getDomain',
      editorialBoard: 'getEditorialBoard',
      country: 'getCountry',
      user: 'getUser'
    })
  },
  async mounted() {
    await this.getJournalList()
    help.closeAutocomplete()
  },
  methods: {
    async getList(page = 1) {
      const data = Object.assign(this.params, {
        pageIndex: page,
        pageSize: this.pagination.size
      })
      const { list, pageIndex, pageSize, total } = await topic.get(data)
      this.dataSource = list
      this.pagination = Object.assign(this.pagination, {
        total,
        size: pageSize,
        current: pageIndex
      })
    },
    async getJournalList() {
      this.journalList = await journal.userGet({ released: true })
      // this.journalList.unshift({
      //   name: 'All',
      //   id: ''
      // })
      this.getList()
    },
    handleDateChange(date, val) {
      this.params[val + 'StartTime'] = date[0] ? date[0].startOf('d') : ''
      this.params[val + 'EndTime'] = date[1] ? date[1].endOf('d') : ''
      this.getList()
    },
    changeStatus(status) {
      this.params.released = status
      this.getList()
    },
    add() {
      this.$router.push('/publishing/topics/add')
    },
    edit(val) {
      this.$router.push('/publishing/topics/edit/' + val.id)
    },
    async able(val) {
      const { id, released, version } = val
      await topic.release(id, !released, {
        version
      })
      let content = 'This Topic has been published!'
      if (released) {
        content = 'This Topic has been unpublished!'
      }
      this.$message.success({
        title: 'Success',
        content: content
      })
      this.getList()
    },
    del(val) {
      this.$confirm({
        title: 'Are you sure you want to delete this topic?',
        content:
          'Please be aware of once this topic is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete'
      }).then(async () => {
        await topic.del(val.id)
        this.$message.success({
          title: 'Success',
          content: 'This Topic has been deleted!'
        })
        this.getList()
      })
    },
    handleClear() {
      this.params.keyword = ''
      this.params.abstractStartTime = ''
      this.params.abstractEndTime = ''
      this.params.manuscriptStartTime = ''
      this.params.manuscriptEndTime = ''
      this.params.opened = ''
      this.params.journalIdList = ''
      this.journalId = []
      this.startDate = []
      this.endDate = []
      this.getList()
    },
    changeJournal(val) {
      this.params.journalIdList = val.join(',')
      this.getList()
    },
    // publish() {},
    article(val) {
      this.$router.push('/publishing/topics/' + val.id)
    },
    onOrderChanage(val) {
      this.params.sorted = val
      this.getList()
    },

    setOrder(val) {
      this.params.sorted = val
      this.getList()
    },
    async openWebsite(val) {
      const { host } = window.location
      const urlList = {}
      let hUrl = ''
      if (
        host.includes('192.168.5') ||
        host.includes('192.168.4.34') ||
        host.includes('102.168.4.21') ||
        host.includes('localhost')
      ) {
        hUrl = 'http://192.168.5.18:3020'
      } else if (
        host.includes('192.168.4.23') ||
        host.includes('imrpress.tech:9100')
      ) {
        hUrl = 'http://www.imrpress.tech'
      } else if (host.includes('imrpress.tech:8100')) {
        hUrl = 'http://www.imrpress.tech:9000'
      } else if (host.includes('propub.com')) {
        hUrl = 'https://www.imrpress.com'
      } else {
        hUrl = 'http://192.168.4.35:3020'
      }
      val.journalList.map((item, index) => {
        let url = `/journal/${item.name}/test/topic/${
          val.code
        }?token=${localStorage.getItem('token')}`
        urlList[item.name]
        window.open(hUrl + url, index)
      })
    },
    cancel() {
      this.isVisablePDF = false
    },
    createCanvans(val, type) {
      this.inputData = val
      this.pdfType = type
      this.isVisablePDF = true
    },
    async exp() {
      this.loading = true
      try {
        const res = await topic.export(this.params)
        help.download(res.url, res.fileName)
      } catch (e) {
        this.loading = false
      }
      this.loading = false
    }
  }
}
